package de.connect2x.timmy.i18n
import de.connect2x.trixnity.messenger.MatrixMessengerSettingsHolder
import de.connect2x.trixnity.messenger.compose.view.i18n.I18nView
import de.connect2x.trixnity.messenger.i18n.DefaultLanguages.DE
import de.connect2x.trixnity.messenger.i18n.DefaultLanguages.EN
import de.connect2x.trixnity.messenger.i18n.GetSystemLang
import de.connect2x.trixnity.messenger.i18n.Languages
import kotlinx.datetime.TimeZone

class I18nViewWcImpl(
    lang: Languages,
    messengerSettings: MatrixMessengerSettingsHolder,
    getSystemLang: GetSystemLang,
    timeZone: TimeZone,
) : I18nView(lang, messengerSettings, getSystemLang, timeZone) {

    override fun commonArchived() = translate {
        EN - "Left"
        DE - "Verlassen"
    }

    fun filePreviewDeactivated() = translate {
        EN - "The sent file is not displayed for security reasons."
        DE - "Aus Sicherheitsgründen wird die gesendete Datei nicht angezeigt"
    }
}
